import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import "../../common/planTheme.css";
import "./ReportView.css";
import { TextField } from "@material-ui/core";
import axios from "axios";
import Swal from "sweetalert2";
import { DecryptED } from "../../DecryptJS/Decrypt";

const ReportView = () => {
  const history = useHistory();
  let { sid, userid, reportid } = useParams();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [classList, setClassList] = useState([]);
  const [lessonName, setLessonName] = useState("");
  const [lessonObjective, setLessonObjective] = useState("");
  const [learningOutcome, setLearningOutcome] = useState("");
  const [pedagogicalPractices, setPedagogicalPractices] = useState("");
  const [audioVisualAdis, setAudioVisualAdis] = useState("");
  const [teacherPreparation, setTeacherPreparation] = useState("");
  const [studentPreparation, setStudentPreparation] = useState("");
  const [additionalExtended, setAdditionalExtended] = useState("");
  const [interdisciplinaryLinkage, setInterdisciplinaryLinkage] = useState("");
  const [infusion, setInfusion] = useState("");
  const [artIntegration, setArtIntegration] = useState("");
  const [storyBased, setStoryBased] = useState("");
  const [artificialIntelligence, setArtificialIntelligence] = useState("");
  const [fln, setFln] = useState("");
  const [remedialPlan, setRemedialPlan] = useState("");
  const [cwsnPlan, setCwsnPlan] = useState("");
  const [assignment, setAssignment] = useState("");
  const [referenceUsed, setReferenceUsed] = useState("");
  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [lessonDuration, setLessonDuration] = useState("");
  const [month, setMonth] = useState("");
  const [subject, setSubject] = useState("");

  const submitForm = async (e) => {
    e.preventDefault();

    const data = {
      fun_name: "updateLessonplanData",
      staff_id: DecryptED(userid),
      sid: DecryptED(sid),
      id: reportid,
      month,
      subject_id: `${subjectId}`,
      classdiv_id: `${classId}`,
      Lessonname: lessonName,
      Lessonduration: `${lessonDuration}`,
      lesson_objective: lessonObjective,
      learning_outcome: learningOutcome,
      pedagogical_practices: pedagogicalPractices,
      audio_visual_adis: audioVisualAdis,
      teacher_preparation: teacherPreparation,
      student_preparation: studentPreparation,
      additional_extended_information: additionalExtended,
      interdisciplinary_linkage: interdisciplinaryLinkage,
      infusion_with_life_skills: infusion,
      art_integration: artIntegration,
      story_based: storyBased,
      artificial_intelligence: artificialIntelligence,
      fln: fln,
      remedial_plan: remedialPlan,
      cwsn_plan: cwsnPlan,
      assignment: assignment,
      reference_used: referenceUsed,
    };
    if (!lessonName.trim()) {
      return Swal.fire("Warning", "Lesson name cannot be empty", "warning");
    }

    setSaving(true);
    try {
      const response = await axios.post(
        "https://topschool.prisms.in/rest/index.php/staff_list.json",
        data
      );
      if (response.data && response.data.success !== false) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `LessonPlan for ${lessonName} has been updated successfully!`,
          showConfirmButton: false,
          timer: 1500,
        });
        history.push(`/report/${sid}/${userid}`);
      } else {
        Swal.fire("Error", (response.data && response.data.message) || "Could not update the lesson plan", "error");
      }
    } catch (e) {
      console.error(e);
      Swal.fire("Error", "Could not update the lesson plan. Please try again.", "error");
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    const getReportData = async () => {
      const data = {
        fun_name: "getLessonPlanByID",
        staff_id: DecryptED(userid),
        sid: DecryptED(sid),
        id: reportid,
      };
      try {
        const response = await axios.post(
          "https://topschool.prisms.in/rest/index.php/staff_list.json",
          data
        );
        const obj = response.data && response.data.result && response.data.result[0];
        if (!obj) {
          Swal.fire("Error", "Lesson plan not found", "error");
          return;
        }
        setLessonName(obj.Lessonname);
        setSubject(obj.subject);
        setClassId(obj.classdiv_id);
        setSubjectId(obj.subject_id === undefined || obj.subject_id === null ? "" : obj.subject_id);
        setLessonDuration(obj.Lessonduration);
        setLessonObjective(obj.lesson_objective);
        setLearningOutcome(obj.learning_outcome);
        setPedagogicalPractices(obj.pedagogical_practices);
        setAudioVisualAdis(obj.audio_visual_adis);
        setTeacherPreparation(obj.teacher_preparation);
        setStudentPreparation(obj.student_preparation);
        setAdditionalExtended(obj.additional_extended_information);
        setInterdisciplinaryLinkage(obj.interdisciplinary_linkage);
        setInfusion(obj.infusion_with_life_skills);
        setArtIntegration(obj.art_integration);
        setStoryBased(obj.story_based);
        setArtificialIntelligence(obj.artificial_intelligence);
        setFln(obj.fln);
        setRemedialPlan(obj.remedial_plan);
        setCwsnPlan(obj.cwsn_plan);
        setAssignment(obj.assignment);
        setReferenceUsed(obj.reference_used);
        setMonth(obj.month);
      } catch (e) {
        console.error(e);
        Swal.fire("Error", "Could not load the lesson plan. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    };

    const getAccessableClass = async () => {
      const data = {
        fun_name: "getAccessClass",
        sid: DecryptED(sid),
        staff_id: DecryptED(userid),
      };
      try {
        const response = await axios.post(
          "https://topschool.prisms.in/rest/index.php/staff_list.json",
          data
        );
        setClassList((response.data && response.data.result) || []);
      } catch (e) {
        console.error(e);
      }
    };

    getReportData();
    getAccessableClass();
  }, [sid, userid, reportid]);
  if (loading) {
    return (
      <div className="lp-scope lessonreportview-page">
        <p className="lp-page-title" style={{ textAlign: "center" }}>Edit Lesson Plan</p>
        <p style={{ textAlign: "center", padding: "20px", color: "#1565c0" }}>
          Loading lesson plan…
        </p>
      </div>
    );
  }

  return (
    <div className="lp-scope lessonreportview-page">
      <p className="lp-page-title" style={{ textAlign: "center" }}>Edit Lesson Plan</p>
      <form className="form lp-card" onSubmit={submitForm}>
        <div className="user-details">
          <p className="lp-section-title">Lesson Details</p>
          <div className="form-details">
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="classDivName">Class</label>
              {classList
                .filter((data) => data.id === classId)
                .map((data) => (
                  <input
                    key={data.id}
                    className="lp-input"
                    value={data.div_name}
                    id="classDivName"
                    type="text"
                    readOnly
                    aria-readonly="true"
                  />
                ))}
            </div>
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="month">Month</label>
              <input
                className="lp-input"
                onChange={(e) => setMonth(e.target.value)}
                name="month"
                id="month"
                type="month"
                value={month}
                required
              />
            </div>
          </div>
          <div className="form-details">
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="subjectName">Subject</label>
              <input
                className="lp-input"
                value={subject}
                id="subjectName"
                type="text"
                readOnly
                aria-readonly="true"
              />
            </div>
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="lessonName">Lesson Name</label>
              <input
                className="lp-input"
                value={lessonName}
                onChange={(e) => setLessonName(e.target.value)}
                id="lessonName"
                type="text"
                required
              />
            </div>
          </div>
          <div className="form-details">
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="lessonDurationDisplay">Lesson Duration</label>
              <input
                className="lp-input"
                value={lessonDuration}
                id="lessonDurationDisplay"
                type="text"
                readOnly
                aria-readonly="true"
              />
            </div>
          </div>
        </div>
        <p className="lp-section-title" style={{ marginTop: "24px" }}>Lesson Content</p>
        <div className="mid-details">
          <div>
            <TextField
              fullWidth
              multiline
              minRows={3}
              id="lessonObjective"
              label="Lesson Objective"
              variant="outlined"
              size="small"
              value={lessonObjective}
              onChange={(e) => setLessonObjective(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              multiline
              minRows={3}
              id="learningOutcome"
              label="Learning Outcome"
              variant="outlined"
              size="small"
              value={learningOutcome}
              onChange={(e) => setLearningOutcome(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              multiline
              minRows={3}
              id="pedagogicalPractices"
              label="Pedagogical Practices"
              variant="outlined"
              size="small"
              value={pedagogicalPractices}
              onChange={(e) => setPedagogicalPractices(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              multiline
              minRows={3}
              id="audioVisualAids"
              label="Audio/VisualAids"
              variant="outlined"
              size="small"
              value={audioVisualAdis}
              onChange={(e) => setAudioVisualAdis(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="teacherPreparation"
              label="Teacher Preparation"
              variant="outlined"
              size="small"
              value={teacherPreparation}
              onChange={(e) => setTeacherPreparation(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="studentPreparation"
              label="Student Preparation"
              variant="outlined"
              size="small"
              value={studentPreparation}
              onChange={(e) => setStudentPreparation(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="additionalExtended"
              label="Additional Extended Information"
              variant="outlined"
              size="small"
              value={additionalExtended}
              onChange={(e) => setAdditionalExtended(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="interdisciplinaryInfo"
              label="Interdisciplinary Information"
              variant="outlined"
              size="small"
              value={interdisciplinaryLinkage}
              onChange={(e) => setInterdisciplinaryLinkage(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="infusionLifeSkills"
              label="Infusion with Life Skills"
              variant="outlined"
              size="small"
              value={infusion}
              onChange={(e) => setInfusion(e.target.value)}
            />
          </div>
        </div>
        <div className="form-supplemental">
          <p className="lp-section-title">Supplemental Activities</p>
          <div>
            <TextField
              fullWidth
              id="artIntegration"
              label="Art-Integration"
              variant="outlined"
              size="small"
              value={artIntegration}
              onChange={(e) => setArtIntegration(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="storyBased"
              label="Story Based"
              variant="outlined"
              size="small"
              value={storyBased}
              onChange={(e) => setStoryBased(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="artificialIntelligence"
              label="Artificial Intelligence"
              variant="outlined"
              size="small"
              value={artificialIntelligence}
              onChange={(e) => setArtificialIntelligence(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="fln"
              label="FLN"
              size="small"
              value={fln}
              onChange={(e) => setFln(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="remedialPlanField"
              label="Remedial Plan"
              size="small"
              value={remedialPlan}
              onChange={(e) => setRemedialPlan(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="cwsnPlanField"
              label="CWSN Plan"
              size="small"
              value={cwsnPlan}
              onChange={(e) => setCwsnPlan(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="assignmentField"
              label="Assignment"
              size="small"
              value={assignment}
              onChange={(e) => setAssignment(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="referenceUsedField"
              label="Reference Used"
              size="small"
              value={referenceUsed}
              onChange={(e) => setReferenceUsed(e.target.value)}
            />
          </div>
        </div>
        <div className="btn-div" style={{ marginTop: "24px" }}>
          <button type="submit" className="lp-btn lp-btn-primary" disabled={saving}>
            {saving ? "Updating…" : "Update"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReportView;
